a<template>
  <div class="navigation">
    <nav class="nav-year">

      <carousel :per-page="numSlides" :navigationEnabled="true" :paginationEnabled="false" :navigate-to="someLocalProperty" :mouse-drag="true">
      <slide v-for="(link) in links" :key="link">
      <router-link
        :class="{ disabled: checkCountry(link)}"
        :event="isDisabled(link)"
        :to="{
          'name': $route.name,
          'params': { year: link }
      }">
        {{ link }}
      </router-link>
    </slide>
    </carousel>

    </nav>
    <nav class="nav-category">

      <router-link :to="{
        'name': 'stats',
        'params': { view: 'portrait', year: $route.params.year }}">Länderportrait
      </router-link>

      <router-link :to="{
        'name': 'stats',
        'params': { view: 'comparison', year: '2024' }}">Rankingverlauf vergleichen
      </router-link>

      <router-link :to="{
        'name': 'stats',
        'params': { view: 'ranking', year: $route.params.year }}">Länderranking
      </router-link>

    </nav>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'navigation',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      someLocalProperty: 0,
      numSlides: this.getSlidesNum(),
    };
  },
  computed: {
    links() {
      return this.$store.state.years;
    },
  },
  mounted() {
    this.$store.dispatch('SET_COUNTRY', {Id: 'de'});
  },
  methods: {
    getSlidesNum() {
      let numSlidesMobile = (this.$globals.x / 70).toFixed(0);
      numSlidesMobile -= 3; // - controls and padding -> 3
      return this.$globals.isMobile ? numSlidesMobile : 8;
    },
    isDisabled(year) {
      if (this.$route.params.view === 'comparison') return '';
      else if (this.$route.params.view === 'portrait' && this.$store.getters.hasCountryDataForYear(year) == false ) return '';
      return 'click';
    },
    checkCountry(year) {
      if (this.$route.params.view === 'comparison') return true
      else if (this.$route.params.view === 'portrait' && this.$store.getters.hasCountryDataForYear(year) == false) return true
      else return false;
    },
  },
};
</script>

<style lang="scss">
.router-link-active {
  cursor: default;
}

.VueCarousel-navigation-button {
    border: 1px solid $color-brand !important;
    color: red $color-black !important;
    background-color: $color-white !important;
    border-radius: $border-radius-btn !important;
    padding: 3px 20px 5px !important;

    &:hover {
      background-color: $color-brand !important;
      color: $color-white !important;
    }

    &.VueCarousel-navigation--disabled {
      &:hover {
        background-color: $color-white !important;
        color: $color-black !important;
      }
    }
}

.nav-year {
  position: relative;
  display: block;
  width: calc(100% - 110px);
  margin: 20px auto;
  a {
    display: inline-block;
    color: $color-link;
    text-decoration: none;
    padding: 4px 20px;
    background-color: $color-white;
    border-radius: $border-radius-btn;
    border: 1px solid $color-brand;

    &.router-link-active,
    &:hover {
      color: $color-white;
      background-color: $color-brand;
    }

    &.disabled {
      cursor: default;
      color: $color-grey-dark;
      border-color: $color-grey-dark;

      &.router-link-active {
        color: $color-white;
        background-color: $color-brand;
        border-color: $color-brand;

        &:hover {
            background-color: $color-brand;
        }
      }

      &:hover {
        background-color: $color-white;
      }
    }
  }

  
}
.nav-category {
  //display: grid;
  //grid-template-columns: 1fr 1fr 1fr;
  //margin: 5px 0 8px;
  background-color: $color-white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: auto;
  gap: 10px;

  a {
    position: relative;
    display: inline-block;
    //padding: 0 0 0 20px;
    color: $color-black;
    text-decoration: none;
    font-size: $fs-subnavi;
    white-space: nowrap;
    background-color: $color-white;
    border: 1px solid $color-brand;
    padding: 4px 20px;
    width: 100%;
    max-width: 310px;
    border-radius: $border-radius-btn;

    &.router-link-active,
    &:hover {
      background-color: $color-brand;
      color: $color-white;
    }

    &.router-link-active {
    }

  }

  @include bp(s) {
    flex-direction: row;
    a {
      width: initial;
      max-width: initial;
    }
  }
}


nav a, .VueCarousel button {
  transition: all $ani-speed;
}
</style>
